
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Retinoblastoma",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Retinoblastoma.vue